/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
'use client'

import { MoreHorizontal } from 'lucide-react'
import { JSX, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

type Props = {
  dropDownMenuContent: JSX.Element
  isExpanded?: boolean
  onClickableButtonClick?(): void
  showClickableButton?: boolean
}

export const ColumnActions = ({
  children,
  dropDownMenuContent,
  isExpanded = false,
  onClickableButtonClick,
  showClickableButton = true,
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation()

  return (
    <div className="text-right flex items-center gap-2 w-fit pl-0 @3xl/table:pl-8 ml-auto">
      {showClickableButton && (
        <Button
          className="hidden @3xl/table:inline-flex group-hover:bg-layer-3"
          onClick={onClickableButtonClick}
          size="lg"
          variant="secondary"
        >
          {isExpanded ? t('global.hide') : t('global.show')}
        </Button>
      )}
      {children}
      <div onClick={e => e.stopPropagation()}>
        <DropdownMenu>
          <Tooltip>
            <TooltipTrigger asChild>
              <DropdownMenuTrigger asChild>
                <Button
                  className={cn({
                    'hover:bg-layer-1': showClickableButton,
                  })}
                  size="icon"
                  variant="ghost"
                >
                  <MoreHorizontal />
                </Button>
              </DropdownMenuTrigger>
            </TooltipTrigger>
            <TooltipContent>{t('global.actions')}</TooltipContent>
          </Tooltip>
          <DropdownMenuContent align="end">{dropDownMenuContent}</DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  )
}
